import { render, staticRenderFns } from "./MyQuotationSurchargeList.vue?vue&type=template&id=04099957&"
import script from "./MyQuotationSurchargeList.vue?vue&type=script&lang=js&"
export * from "./MyQuotationSurchargeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04099957')) {
      api.createRecord('04099957', component.options)
    } else {
      api.reload('04099957', component.options)
    }
    module.hot.accept("./MyQuotationSurchargeList.vue?vue&type=template&id=04099957&", function () {
      api.rerender('04099957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationSurchargeList.vue"
export default component.exports